var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:({
    width: _vm.grid.cols * 75 - _vm.grid.cols + 'px !important',
    height: _vm.grid.rows * 75 - _vm.grid.rows + 'px !important',
    //top: '50%',
    left: '50%',
    transform: 'translate(-50%,0)',
  })},[(_vm.grid.cells != '')?_c('div',_vm._l((_vm.grid.rows),function(r){return _c('div',{key:r},_vm._l((_vm.grid.cols),function(c){return _c('div',{key:c},[_c('CA',{attrs:{"col":c,"row":r,"dta":_vm.giveMeValue(r, c),"showrep":_vm.showRep,"assisted":_vm.gAssisted,"val":_vm.grid.result['r' + c + r],"creation":_vm.gCreation},on:{"change":_vm.doChange}})],1)}),0)}),0):[_vm._v("Pas de grille sélectionnée !")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }